import React from 'react';
import cls from '@utils/css-select'
import styles from './styles.scss';

const cx = cls(styles)

function Container (props: { children: React.ReactNode; className?: string }) {
	return (
		<section className={cx('container', props.className)}>
			{ props.children }
		</section>
	)
}

export default Container
